/* eslint-disable react-hooks/exhaustive-deps */
import Box from '@cavilha/box';
import Toggle from '@cavilha/toggle';
import { useListFilter } from '@hooks/algolia/useListFilter';
import { connectToggleRefinement } from 'react-instantsearch-dom';

type ToggleRefinementListProps = {
  label: string;
  count: Record<string, number>;
  value: string;
  refine: Function;
  currentRefinement: any;
  attribute: any;
  type: any;
  position: number;
  typeFixedPosition: number;
};

const ToggleRefinementList = connectToggleRefinement(
  ({
    label,
    refine,
    count,
    currentRefinement,
    type,
    position,
    typeFixedPosition,
  }: ToggleRefinementListProps) => {
    const totalItems = count?.unchecked;

    const { trackListFilter } = useListFilter();

    return (
      <Box css={{ mb: '15px' }}>
        {totalItems && totalItems !== undefined ? (
          <Toggle
            alternativeLabel={label}
            count={totalItems}
            label={label}
            onPressedChange={() => {
              const isChecked = !currentRefinement;
              if (isChecked)
                trackListFilter({
                  typeFixedPosition,
                  typeName: type,
                  elementName: label,
                  elementPosition: position + 1,
                });
              refine(isChecked);
            }}
            isPressed={currentRefinement}
            size="small"
            variation="count"
          />
        ) : null}
      </Box>
    );
  }
);

export default ToggleRefinementList;
